/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createSlice } from '@reduxjs/toolkit'
import audit from '../../../lib/audit'


export enum Level {
    TABS_WARNING = 1,
    BACKGROUND_WARNING = 2,
    CAMERA_WARNING = 3
}

export const Messages = {
    1: 'Close inactive tabs and apps to improve your video quality.',
    2: 'Close inactive tabs and apps and disable virtual background to improve your video quality. ',
    3: 'Video frame rate is too low, consider turning off your camera. '
}

export interface QualityWarningSlice {
  closed: boolean
  stats: any[]
  level: Level | null
  text: string | null
}

export const QualityWarningDefaultState: QualityWarningSlice = {
  closed: true,
  stats: [],
  level: null,
  text: null
}

const qualityWarningSlice = createSlice({
  name: 'qualityWarning',
  initialState: QualityWarningDefaultState,
  reducers: {
    setStats(state, { payload }) {
        state.stats.push(payload)
    },
    clearStats( state ) {
        state.stats = []
    },
    activate( state, { payload } ) {
      state.level = payload
      state.text = Messages[payload]
      state.closed = false
    },
    close ( state ) {
        state.closed = true
    }
  }
})

export const close = () => async (dispatch, getState) => {

    const { user, qualityWarning } = getState()

    dispatch(qualityWarningSlice.actions.close())
    audit.addEntry('PresenterService', 'WarningDisplayClose', JSON.stringify({userId: user.BTID, warningType: qualityWarning.level}), undefined, undefined, false)

  
}


export default qualityWarningSlice
